// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".promo-layout{height:100%;min-height:100vh;width:100vw;max-width:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.promo-layout .backdrop .modal-slot{margin:10vh auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
